
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.6786 16.2012L17.2382 8.5575C17.5396 8.05169 17.1626 7.41943 16.5587 7.41943H7.44065C6.8379 7.41943 6.45975 8.05169 6.76227 8.5575L11.3207 16.2012C11.6221 16.707 12.3773 16.707 12.6786 16.2012Z","fill":"#16171F"}})])
          )
        }
      }
    